import React from 'react';
import { Alert } from 'react-bootstrap';
import { groupSessionsByMonth } from '../../utilities/agendamentoSeries';

// Resumo do lote salvo: é o que a recepção lê para o paciente.
// Também o do "Salvar e enviar" de um agendamento só (novo ou aberto pela agenda, com updated)
function summaryTitle(summary) {
  if (summary.updated) return 'Agendamento atualizado';
  return summary.sessions.length === 1 ? '1 agendamento cadastrado' : `${summary.sessions.length} agendamentos cadastrados`;
}

const AgendamentoBatchSummary = ({ summary }) => {
  const groups = groupSessionsByMonth(summary.sessions, summary.startTime);
  const details = [summary.tipo, summary.status].filter(Boolean).join(' · ');

  return (
    <Alert variant='success' className='mb-0'>
      <div className='d-grid gap-1'>
        <b>{summaryTitle(summary)}</b>
        <span>{summary.paciente} com {summary.tecnico}{details ? ` · ${details}` : ''}</span>
        {groups.map((group) => (
          <span key={group.title}><b>{group.title}</b> {group.items.join(' · ')}</span>
        ))}
      </div>
    </Alert>
  );
};

export default AgendamentoBatchSummary;
